import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, AlertTriangle, ShieldQuestion } from 'lucide-react';

const LABELS = { w9: 'W-9', coi: 'COI', ach: 'ACH' };

/**
 * Inline badge showing carrier packet compliance status.
 *
 * Props:
 *   status: "complete" | "partial" | "missing" | "unknown"
 *   missing: string[]                — list of missing doc keys
 *   size:   "sm" | "md"              — defaults md
 */
const CarrierPacketBadge = ({ status, missing = [], size = 'md' }) => {
  const small = size === 'sm';
  const padding = small ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs';

  if (status === 'complete') {
    return (
      <Badge
        data-testid="carrier-packet-badge-complete"
        className={`bg-green-500/20 text-green-300 border-green-500/30 ${padding} gap-1`}
      >
        <CheckCircle2 className={small ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
        Packet Complete
      </Badge>
    );
  }
  if (status === 'partial' || status === 'missing') {
    const labels = (missing || []).map((m) => LABELS[m] || m.toUpperCase()).join(', ');
    return (
      <Badge
        data-testid="carrier-packet-badge-pending"
        className={`bg-amber-500/20 text-amber-300 border-amber-500/30 ${padding} gap-1`}
        title={labels ? `Missing: ${labels}` : undefined}
      >
        <AlertTriangle className={small ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
        Pending{labels ? ` · Missing: ${labels}` : ''}
      </Badge>
    );
  }
  return (
    <Badge
      data-testid="carrier-packet-badge-unknown"
      className={`bg-zinc-700/60 text-zinc-300 border-zinc-600 ${padding} gap-1`}
    >
      <ShieldQuestion className={small ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
      Not on file
    </Badge>
  );
};

export default CarrierPacketBadge;
